import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Access from "../../assets/images/access.png";
const NotAllowed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    document.addEventListener("localdatachanged", () => {
      if (
        localStorage.getItem("menuStructure") &&
        JSON.parse(localStorage.getItem("menuStructure"))?.length
      ) {
        navigate("/");
      }
    });
  }, []);
  return (
    <div
      style={{
        width: "100%",
        height: "85vh",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div>
        <img src={Access} alt="icon" width="150px" />
        <h1>{t("access-not-granted")}</h1>
        <p style={{ marginTop: "10px" }}>
          {t("access-not-granted-description")}
        </p>
      </div>
    </div>
  );
};

export default NotAllowed;
